import type { CSSProperties } from 'react';

export const timelineControlStyle : CSSProperties = {
    height : '70px',
    alignContent : 'center',
    padding : '0 16px',
    backdropFilter : 'blur(10px)'
}

export const panelBackdropStyle : CSSProperties = {
    height : '100%',
    width : '100%',
}

export const splitterCollapseIconStyle : CSSProperties = {
    width : 26,
    height : 48,
    display : 'inline-flex',
    alignItems : 'center',
    justifyContent : 'center',
    borderRadius : 8,
    color : '#ffffff',
    background : 'rgba(215, 0, 11, 0.82)',
    border : '1px solid rgba(255, 255, 255, 0.26)',
    boxShadow : '0 8px 22px rgba(215, 0, 11, 0.28)',
    right : '8px',
}

